var map = {
	"./introduce-green-1.png": "UHie",
	"./introduce-green-2.png": "wfhw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i80S";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/introduce\-green\-.*\.png$
// module id = i80S
// module chunks = 1